import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const RestartButton = ({ shouldDisplayRestartButton, translate, onClickHandler, spinnerToggle }) => {
  const theme = useTheme();
  if (!shouldDisplayRestartButton) {
    return null;
  }

  return (
    <VideoPlayerButtonComponent
      src={process.env.PUBLIC_URL + "/images/Restart.svg"}
      alt={translate("restart")}
      buttonClassName="playbackButton"
      onClickHandler={onClickHandler}
      disabled={spinnerToggle}
      tooltipDirection="top"
      $hoverBackgroundColor={theme.colours.mineShaftGray}
    />
  );
};

export default RestartButton;
